import styled from 'styled-components';

// ----------------------------------------------------------------------

export const Container = styled.div`
  width: 100%;
  min-height: 100vh;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  padding: 120px 40px;
  position: relative;
  background-color: ${({theme}) => theme.colors.grayscale[50]};
    
  ${({theme}) => theme.media.lg`
    padding: 40px 10px;
  `};
    
  ${({theme}) => theme.media.md`
    background-color: #FFFFFF;
  `};
`;

export const Copyright = styled.p`
  font-size: 14px;
  position: absolute;
  bottom: 80px;
  left: 50%;
  transform: translateX(-50%);
  color: ${({theme}) => theme.colors.grayscale[400]};
    
  ${({theme}) => theme.media.lg`
    font-size: 13px;
    bottom: 20px;
    width: 100%;
    left: 0;
    transform: unset;
    text-align: center;
  `};
`;